import Vue from 'vue'

Vue.component('home', require('./home').default);
Vue.component('pages-404', require('./utility/404').default);

Vue.component("login", require("./account/login").default);
Vue.component("register", require("./account/register").default);
Vue.component("forgot-password", require("./account/forgot-password").default);
Vue.component("reset-password", require("./account/reset-password").default);

Vue.component("config-configuracion",  require("./config/configuracion").default);
Vue.component("config-marcas",      require("./config/marcas").default);
Vue.component("config-medidas",     require("./config/medidas").default);
Vue.component("config-categorias",  require("./config/categorias").default);
Vue.component("config-tipos",        require("./config/tipos").default);
Vue.component("config-ubicaciones",  require("./config/ubicaciones").default);
Vue.component("config-ingredientes",  require("./config/ingredientes").default);
Vue.component("config-clientes",  require("./config/clientes").default);
Vue.component("config-profile",  require("./config/profile").default);
Vue.component("config-turnos",  require("./config/turnos").default);
Vue.component("config-canales",  require("./config/canales").default);
Vue.component("config-productos",  require("./config/productos").default);
Vue.component("config-comandas",  require("./config/comandas").default);
Vue.component("config-reportes",  require("./config/reportes").default);
Vue.component("config-socios",  require("./config/socios").default);

Vue.component("caja-pedidos",  require("./caja/pedidos").default);
Vue.component("chat-ataraxia",  require("./chat/ataraxia").default);